import React from "react";
import AboutMe from "../Sections/AboutMe/AboutMe";
import Banner from "../Sections/Banner/Banner";
import ContactMe from "../Sections/ContactMe/ContactMe";
import MySkills from "../Sections/MySkills/MySkills";
import Projects from "../Sections/Projects/Projects";

const Home = () => {
  return (
    <div>
      <Banner></Banner>
      <AboutMe></AboutMe>
      <MySkills></MySkills>
      <Projects></Projects>
      <ContactMe></ContactMe>
    </div>
  );
};

export default Home;
